import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import * as hotjarTracking from '@hotjar/webapp/tracking/tools/hotjar';
import { extractAccountGroupingProps } from '@hotjar/webapp/tracking/utils';

import type { OwnedAccount, SiteAccount, Account } from '@hotjar/account';

interface Verify3DSCalled {
  amountCharged: string;
  bin: string;
  account: Account | SiteAccount | OwnedAccount;
}

/**
 * Payment and 3DS-specific events.
 * @param {string} amountCharged The amount charged
 * @param {number|undefined} bin Bin number for the payment method.
 */
export function verify3DSCalled({ account, amountCharged, bin }: Verify3DSCalled): void {
  const trackingKey = '3DS Challenge Requested';

  const data = {
    ...extractAccountGroupingProps(account),
    amount: parseFloat(amountCharged),
    ...(bin ? { bin } : {}),
  };

  Segment.track(trackingKey, data);
  hotjarTracking.tagRecording(trackingKey);
}
